import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Layout from "../components/feature/Layout";
import Home from "../pages/home/page";
import FoodCategory from "../pages/food-category/page";
import FoodDetail from "../pages/food-detail/page";
import Courier from "../pages/courier/page";
import CourierSend from "../pages/courier-send/page";
import CourierTrack from "../pages/courier-track/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "food-category", element: <FoodCategory /> },
      { path: "food-detail/:id", element: <FoodDetail /> },
      { path: "courier", element: <Courier /> },
      { path: "courier-send", element: <CourierSend /> },
      { path: "courier-track", element: <CourierTrack /> },
      { path: "about", element: <About /> },
      { path: "contact", element: <Contact /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;